import React from 'react';

export const HeroLogo = () => {
  return (
    <div className="d-flex justify-content-center">
      <svg
        width="44"
        height="36"
        viewBox="0 0 44 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_66_779)">
          <path
            d="M0 26.9978H9.23381L18.4556 8.01342L24.8037 17.5747L28.4866 9.21612L24.7404 3.5736C23.259 1.33902 20.7718 0 18.1084 0C15.0635 0 12.2855 1.74625 10.9444 4.50367L0 26.9978Z"
            fill="url(#paint0_linear_66_779)"
          />
          <path
            d="M44 9.00223H34.7662L25.5444 27.9867L19.1963 18.4254L15.5134 26.7839L19.2596 32.4265C20.741 34.6576 23.2282 35.9966 25.8899 35.9966C28.9348 35.9966 31.7128 34.2504 33.0539 31.493L43.9983 8.99878L44 9.00223Z"
            fill="url(#paint1_linear_66_779)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_66_779"
            x1="28.4866"
            y1="13.4989"
            x2="0"
            y2="13.4989"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2AAE3F" />
            <stop offset="0.15" stopColor="#289E46" />
            <stop offset="0.44" stopColor="#247758" />
            <stop offset="0.83" stopColor="#1D3876" />
            <stop offset="1" stopColor="#1B1B84" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_66_779"
            x1="44"
            y1="22.5012"
            x2="15.5134"
            y2="22.5012"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2AAE3F" />
            <stop offset="0.15" stopColor="#289E46" />
            <stop offset="0.44" stopColor="#247758" />
            <stop offset="0.83" stopColor="#1D3876" />
            <stop offset="1" stopColor="#1B1B84" />
          </linearGradient>
          <clipPath id="clip0_66_779">
            <rect width="44" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
